import {Directive, ElementRef, EventEmitter, inject, Input, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';

@Directive({
    selector: '[appBlurWhen]'
})
export class BlurWhenDirective implements OnDestroy {

  private event: EventEmitter<void> | null = null;
  private subscription: Subscription | null = null;
  private readonly element = inject(ElementRef);

  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  @Input('appBlurWhen')
  public set attachedEvent(value: EventEmitter<void> | null) {
    if (this.event === value) {
      return;
    }

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.event = value;
    if (value) {
      this.subscription = value.subscribe(() => this.onEvent());
    }
  }

  private onEvent(): void {
    const nativeElement: HTMLElement = this.element.nativeElement as HTMLElement;
    if (typeof (nativeElement.blur) === 'function') {
      nativeElement.blur();
    }
  }
}
